export default {"src":"/_next/static/media/ki.79c70fab.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};